import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import ConcreteMaterialFormItem from './components/ConcreteMaterialFormItem'
import ConcreteMixDesignFormItem from './components/ConcreteMixDesignFormItem'
import CIMSSection from 'components/CIMSSection'
const Help = HelpMessage.Concrete.Notifications

const RenderFormItems: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Concrete Test Set')}
      >
        <CIMSFormItem label="Recipients" name="recipients">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      <CIMSSection
        title="Concrete Material"
        help={Help.ByConcreteMaterial(event)}
      >
        <CIMSFormItem name="concreteMaterial">
          <ConcreteMaterialFormItem />
        </CIMSFormItem>
      </CIMSSection>
      <CIMSSection
        title="Concrete Mix Design"
        help={Help.ByConcreteMixDesign(event)}
      >
        <CIMSFormItem name="concreteMixDesign">
          <ConcreteMixDesignFormItem />
        </CIMSFormItem>
      </CIMSSection>
    </>
  )
}

export default RenderFormItems
